import {networkDeviceContentConstants} from "../constants/network-device-content.constants";

const initState = {
    currentNetworkDeviceContent: null,
    singleNetworkDeviceContent: null,
    defaultApps: null,
    launcherDropdown: []
};

export function networkDeviceContentReducer(state = initState, action) {
    switch (action.type) {
        case networkDeviceContentConstants.NETWORK_DEVICE_CONTENT_BY_ID_SUCCESS:
            return {
                ...state,
                currentNetworkDeviceContent: action.networkDeviceContentModel
            };
        case networkDeviceContentConstants.NETWORK_DEVICE_CONTENT_BY_ID_FAILURE:
            return {
                ...state,
                currentNetworkDeviceContent: null,
            };
        case networkDeviceContentConstants.NETWORK_DEVICE_CONTENT_BY_CONTENT_ID_REQUEST:
            return {
                ...state,
                singleNetworkDeviceContent: null,
            };
        case networkDeviceContentConstants.NETWORK_DEVICE_CONTENT_BY_CONTENT_ID_SUCCESS:
            return {
                ...state,
                singleNetworkDeviceContent: action.networkDeviceContentModel
            };
        case networkDeviceContentConstants.NETWORK_DEVICE_CONTENT_CLEAR:
            return {
                ...state,
                currentNetworkDeviceContent: null
            };
        case networkDeviceContentConstants.NETWORK_DEVICE_CONTENT_DEFAULT_APP_SUCCESS:
            return  {
                ...state,
                defaultApps: action.defaultAppModel
            };
        case networkDeviceContentConstants.LAUNCHER_DROPDOWN_REQUEST:
            return  {
                ...state,
                launcherDropdown: []
            }
        case networkDeviceContentConstants.LAUNCHER_DROPDOWN_SUCCESS:
            return  {
                ...state,
                launcherDropdown: action.launcherList
            }
        case networkDeviceContentConstants.LAUNCHER_DROPDOWN_FAILURE:
            return  {
                ...state,
                launcherDropdown: []
            }
        default: {
            return state
        }
    }
}
